import { lazy } from 'react';
var AsyncLockCircleIcon = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_mention/LockCircleIcon" */'@atlaskit/icon/core/migration/lock-locked--lock-circle').then(function (module) {
    return {
      default: module.default
    };
  });
});
export default AsyncLockCircleIcon;